import type { AgentStep, Answer, AskEvent } from '../api/schemas';

export type Turn = {
  id: string;
  question: string;
  steps: AgentStep[];
  draft: string;
  answer: Answer | null;
  error: string | null;
  /** The user pressed Stop; whatever streamed so far stays visible. */
  stopped: boolean;
  startedAt: number;
  /** Set when this turn was sent to the research desk, so the analyst's reply survives a reload. */
  deskQuestionId?: string | undefined;
};

export const newTurn = (question: string): Turn => ({
  id: crypto.randomUUID(),
  question,
  steps: [],
  draft: '',
  answer: null,
  error: null,
  stopped: false,
  startedAt: Date.now(),
});

/** Pure reducer: folds one streamed event into the turn. */
export function applyEvent(turn: Turn, evt: AskEvent): Turn {
  switch (evt.event) {
    case 'step': {
      const exists = turn.steps.some((s) => s.id === evt.data.id);
      const steps = exists
        ? turn.steps.map((s) => (s.id === evt.data.id ? evt.data : s))
        : [...turn.steps, evt.data];
      return { ...turn, steps };
    }
    case 'delta':
      return { ...turn, draft: turn.draft + evt.data.text };
    case 'reset':
      return { ...turn, draft: '' };
    case 'answer':
      return { ...turn, answer: evt.data, draft: evt.data.text };
    case 'error':
      return { ...turn, error: evt.data.message };
  }
}

export const isRunning = (turn: Turn) => turn.answer === null && turn.error === null && !turn.stopped;
